import React, { useEffect, useState } from 'react';
import { Button, Form, InputGroup, Alert } from 'react-bootstrap';
import { setIsLoading } from '../general/actions';
import { connect } from 'react-redux';
import axiosInstance from '../general/axiosInstance';

function Logs({ setIsLoading }) {
    const [lines, setLines] = useState(100);
    const [logContent, setLogContent] = useState('');
    const [error, setError] = useState('');
    const [lastFetch, setLastFetch] = useState(null);

    useEffect(() => { fetchLogs(); }, []);

    const fetchLogs = async (n = lines) => {
        setIsLoading(true);
        setError('');
        try {
            const response = await axiosInstance.get('/logs', { params: { lines: n } });
            const data = response.data;
            if (typeof data === 'string') {
                setLogContent(data);
            } else if (Array.isArray(data)) {
                setLogContent(data.map(l => typeof l === 'string' ? l : JSON.stringify(l)).join('\n\n'));
            } else {
                setLogContent(JSON.stringify(data, null, 2));
            }
            setLastFetch(new Date().toLocaleTimeString('es-CO'));
        } catch (err) {
            setError('No se pudo obtener el log del servidor.');
            console.log(err);
        } finally {
            setIsLoading(false);
        }
    };

    const deleteLogs = async () => {
        if (!window.confirm('¿Eliminar el log del sistema? Esta acción no se puede deshacer.')) return;
        setIsLoading(true);
        setError('');
        try {
            await axiosInstance.delete('/logs');
            setLogContent('');
            setLastFetch(new Date().toLocaleTimeString('es-CO'));
        } catch (err) {
            setError('No se pudo eliminar el log.');
            console.log(err);
        } finally {
            setIsLoading(false);
        }
    };

    const handleLines = (e) => {
        const val = Math.min(500, Math.max(1, parseInt(e.target.value) || 100));
        setLines(val);
    };

    return (
        <div style={{ marginTop: 16 }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 12, marginBottom: 16 }}>
                <div>
                    <h5 style={{ fontWeight: 800, margin: 0 }}>
                        <i className="fa fa-terminal" style={{ color: 'var(--abi-primary)', marginRight: 8 }} />
                        Log del sistema
                    </h5>
                    {lastFetch && (
                        <span style={{ fontSize: 12, color: 'var(--abi-muted)' }}>
                            Última actualización: {lastFetch}
                        </span>
                    )}
                </div>

                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <InputGroup style={{ width: 160 }}>
                        <InputGroup.Text style={{ fontSize: 12 }}>Líneas</InputGroup.Text>
                        <Form.Control
                            type="number"
                            value={lines}
                            min={1}
                            max={500}
                            onChange={handleLines}
                            style={{ fontSize: 13 }}
                        />
                    </InputGroup>
                    <Button variant="primary" size="sm" onClick={() => fetchLogs(lines)}>
                        <i className="fa fa-refresh" /> Actualizar
                    </Button>
                    <Button variant="outline-danger" size="sm" onClick={deleteLogs}>
                        <i className="fa fa-trash" /> Eliminar log
                    </Button>
                </div>
            </div>

            {error && <Alert variant="danger">{error}</Alert>}

            <pre style={{
                background: '#1e1e1e',
                color: '#d4d4d4',
                fontFamily: "'Consolas', 'Courier New', monospace",
                fontSize: 12,
                padding: '16px',
                borderRadius: 8,
                overflowX: 'auto',
                overflowY: 'auto',
                maxHeight: '70vh',
                whiteSpace: 'pre-wrap',
                wordBreak: 'break-all',
                margin: 0,
            }}>
                {logContent || 'Sin contenido'}
            </pre>
        </div>
    );
}

function mapStateToProps(state) {
    return { isLoading: state.isLoading };
}

const mapDispatchToProps = { setIsLoading };

export default connect(mapStateToProps, mapDispatchToProps)(Logs);
